exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".align-right {\r\n    text-align: right;\r\n}\r\n\r\n.import-container {\r\n    width: 100%;\r\n    margin-top: 15px;\r\n}\r\n\r\n.full-width {\r\n    width: 100%;\r\n}\r\n\r\n.errors {\r\n    margin-top: 10px;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.error {\r\n    color: #B71C1C;\r\n    font-weight: bold;\r\n    margin: 0px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/import-game-dialog/import-game-dialog.component.css
// module id = ../../../../../src/app/generator/import-game-dialog/import-game-dialog.component.css
// module chunks = main